import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButtonFlat from './CustomButtonFlat';
import Box from '@material-ui/core/Box';


// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Planofaction() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            次世代育成支援対策推進法に基づく一般事業主行動計画
          </Typography>
          <div className="line200">
            従業員がその能力をより発揮し、仕事と生活の調和を図り、働きやすい職場環境の整備を行うため、次のように行動計画を策定する。
          </div>
          <dl>
            <dt><ArrowRightIcon/>計画期間</dt>
            <dd>
              令和３年１０月１日から令和８年９月３０日までの５年間
            </dd>
            <dt><ArrowRightIcon/>内　容</dt>
            <dd>
              <Box m={2}>
                <div className="font-weight-bold">
                  目標１：男性従業員について、子どもが生まれる際の休暇、また育児休業が取得しやすい環境の整備を行う。
                </div>
                <div className="line200">
                  <ol>
                    <li>産前産後・育休中の社会保険料免除、育児・介護休業法に基づく育児休業や時間外労働・深夜業の制限、雇用保険法に基づく育児休業給付、労働基準法に基づく産前産後休業など諸制度の周知を図る</li>
                    <li>男性従業員も配偶者の出産にかかる休暇、また育児休業を取得することができることを周知し、取得促進を呼びかける</li>
                    <li>相談窓口を作り、いつでも従業員からの相談に乗ることができるようにする</li>
                  </ol>
                </div>
              </Box>

              <Box m={2}>
                <div className="font-weight-bold">
                  目標２：年次有給休暇の取得日数を一人当たり平均年間１０⽇以上とする。
                </div>
                <div className="line200">
                  <ol>
                    <li>社員に有休取得の意識づけを行う</li>
                    <li>過去の取得状況を個人別・部署別に一覧化し、取得促進策を検討する</li>
                    <li>取得率の低い部署へのフォロー、有休取得が少ない従業員に対する働きかけを行う</li>
                    <li>計画有休の消化と有休奨励日の積極的活用を図る</li>
                  </ol>
                </div>
              </Box>

              <Box m={2}>
                <div className="font-weight-bold">
                  目標３：地域学校からのインターンシップ（職業体験学習）を継続的に受け入れ、若年者の勤労意識の醸成に貢献する。
                </div>
                <div className="line200">
                  <ol>
                    <li>複数部署の仕事を体験させ、将来の職種選択に役立ててもらう</li>
                    <li>参加者の感想を基に次回以降の内容を改善し、よりよい体験機会を提供する</li>
                  </ol>
                </div>
              </Box>
            </dd>
          </dl>
        </Box>
      </div>
    </div>
  );
}

export default Planofaction;
